<script lang="ts">
  import type { Snippet } from "svelte";
  interface Props {
    title: string;
    description?: string;
    action?: Snippet;
  }
  const { title, description, action }: Props = $props();
</script>

<div class="empty">
  <!-- Decorative only: the mark repeats what the heading below already says, so it
       stays out of the accessibility tree. 1.8 is the console's icon weight (nav,
       plan checks, hamburger) — 2 read heavier than everything around it. -->
  <div class="empty-mark" aria-hidden="true">
    <svg viewBox="0 0 48 48"><rect x="8" y="12" width="32" height="24" rx="4" fill="none" stroke="currentColor" stroke-width="1.8" /><path d="M8 20h32" stroke="currentColor" stroke-width="1.8" /></svg>
  </div>
  <h3>{title}</h3>
  {#if description}<p>{description}</p>{/if}
  {#if action}<div class="empty-action">{@render action()}</div>{/if}
</div>

<style>
  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 10px;
    padding: 48px 24px;
    color: var(--muted);
  }
  .empty-mark {
    color: var(--accent-dim);
    opacity: 0.6;
  }
  .empty-mark svg {
    width: 42px;
    height: 42px;
  }
  h3 {
    font-size: 16px;
  }
  p {
    max-width: 42ch;
    margin: 0;
    font-size: 14px;
  }
  .empty-action {
    margin-top: 8px;
  }
</style>
